// @ts-expect-error not migrated to TS
import CreateEmailButtonTooltips from './CreateEmailButtonTooltips';
// @ts-expect-error not migrated to TS
import EmailCreationModalContainer from './EmailCreationModalContainer';
import { getUsageTracker, trackCreateEmailInteraction, trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import { navigateTo } from 'EmailComponents/utils/urlUtils';
import { dismissFirstEmailZeroState } from 'EmailData/actions/createEmail';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import Raven from 'raven-js';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import EmailCreationTeamAssignPanel from './EmailCreationTeamAssignPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function teamsAreFilterable(teams) {
  if (!teams || teams.length === 0) {
    return false;
  }
  const hasNoChildTeams = teams.every(team => !team.childTeams || team.childTeams.length === 0);
  return !(teams.length === 1 && hasNoChildTeams);
}
function getOnlyAssignedTeam(teams) {
  if (!teams || teams.length === 0) {
    return [];
  }
  return [teams[0].id];
}
export default function CreateEmailButton({
  autoStartOnboarding,
  hasActiveDomains,
  hasEmailCreatePermission,
  isProductReadOnly,
  shouldDisableCreateEmailAction,
  editorHref,
  fetchTeamsLoading,
  mergedEditorHref,
  shouldShowEmailCreationModal,
  hasAssignAssetAccess,
  isDashboardEmptyState,
  isUngatedForAssignTeamInCreation,
  teams,
  use,
  emailCreationComponent,
  ButtonComponent
}) {
  const dispatch = useDispatch();
  const [hasClickedOnce, setHasClickedOnce] = useState(false);
  const [showEmailTemplateModeModal, setShowEmailTemplateModeModal] = useState(false);
  const [showTeamAssignPanel, setShowTeamAssignPanel] = useState(false);
  const [selectedTeamIds, setSelectedTeamIds] = useState([]);
  const startOnboarding = useCallback(() => {
    // For every other case we will open the creation modal if they
    // can pick multiple email types.
    if (shouldShowEmailCreationModal) {
      if (isUngatedForAssignTeamInCreation && hasAssignAssetAccess && teamsAreFilterable(teams) && teams.length > 1) {
        setShowTeamAssignPanel(true);
      } else {
        setShowEmailTemplateModeModal(true);
      }
    }
    // If they can't we'll navigate straight to the template picker.
    else {
      setHasClickedOnce(true);
      navigateTo(editorHref);
    }
  }, [shouldShowEmailCreationModal, isUngatedForAssignTeamInCreation, hasAssignAssetAccess, teams, editorHref]);
  const onClick = useCallback(() => {
    trackDashboardInteraction({
      otherActions: 'create-new-email-button',
      willTriggerOnboarding: autoStartOnboarding !== null && autoStartOnboarding !== void 0 ? autoStartOnboarding : false
    });
    trackCreateEmailInteraction();
    if (isDashboardEmptyState) {
      trackDashboardInteraction({
        otherActions: 'create-email-from-dashboard-empty-state'
      });
    }
    dispatch(dismissFirstEmailZeroState(autoStartOnboarding !== null && autoStartOnboarding !== void 0 ? autoStartOnboarding : false)).finally(() => {
      startOnboarding();
    }).catch(err => {
      Raven.captureException(new Error('dismissFirstEmailZeroState returned an exception'), {
        extra: {
          message: err.message,
          response: err.responseJSON
        }
      });
    });
  }, [autoStartOnboarding, dispatch, isDashboardEmptyState, startOnboarding]);
  const button = useMemo(() => {
    const commonProps = {
      disabled: shouldDisableCreateEmailAction || !hasActiveDomains,
      onClick
    };
    return ButtonComponent ? /*#__PURE__*/_jsx(ButtonComponent, Object.assign({}, commonProps, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.emailCreation.buttonText"
      })
    })) : /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, commonProps, {
      "data-test-id": "email-create-button",
      failed: true // go from loading to text "Create email" directly without "check mark"
      ,
      loading: hasClickedOnce || fetchTeamsLoading,
      size: "sm",
      use: use || 'primary',
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.emailCreation.buttonText"
      })
    }));
  }, [ButtonComponent, fetchTeamsLoading, hasActiveDomains, hasClickedOnce, onClick, shouldDisableCreateEmailAction, use]);
  const EmailCreationComponentToUse = useMemo(() => {
    return emailCreationComponent !== null && emailCreationComponent !== void 0 ? emailCreationComponent : EmailCreationModalContainer;
  }, [emailCreationComponent]);
  const selectedTeamIdsPassedToCreationModal = useMemo(() => {
    if (!hasAssignAssetAccess) {
      return [];
    }
    return teamsAreFilterable(teams) ? selectedTeamIds : getOnlyAssignedTeam(teams);
  }, [hasAssignAssetAccess, selectedTeamIds, teams]);
  return /*#__PURE__*/_jsx(CreateEmailButtonTooltips, {
    hasActiveDomains: hasActiveDomains,
    hasEmailCreatePermission: hasEmailCreatePermission,
    isProductReadOnly: isProductReadOnly,
    children: /*#__PURE__*/_jsxs("span", {
      children: [button, showTeamAssignPanel && /*#__PURE__*/_jsx(EmailCreationTeamAssignPanel, {
        fetchedTeams: teams,
        selectedTeamIds: selectedTeamIds,
        setSelectedTeamIds: setSelectedTeamIds,
        setShowTeamAssignPanel: setShowTeamAssignPanel,
        setShowEmailTemplateModeModal: setShowEmailTemplateModeModal
      }), showEmailTemplateModeModal && /*#__PURE__*/_jsx(EmailCreationComponentToUse, {
        autoStartOnboarding: autoStartOnboarding,
        mergedHref: mergedEditorHref,
        onClose: () => setShowEmailTemplateModeModal(false),
        selectedTeamIds: selectedTeamIdsPassedToCreationModal,
        tracker: getUsageTracker()
      })]
    })
  });
}